import React from 'react';
import { Text } from "../../Atoms";
import { IconTitleMolecule } from '../../Molecules';
import PropTypes from 'prop-types';
import { TemplateRetryButton } from './../../Templates/index';

function TemplatePaiementErreur({ mail, pathToPaiement }) {
    return (
      <div className="template-scroll template-container template-paiement mt-20 d-flex flex-column">
        <div className="content-large-max">
          <IconTitleMolecule
            text="Une erreur s'est produite lors de votre tentative de paiement"
            className="title-page font-title mt-40"
            icon="alert-error"
            size='icon-x2'
          />
          <Text
            type='H8'
            text="Une erreur technique est survenue lors de la tentative de paiement de votre échéance. Notre système n'a pas pu finaliser l'opération."
            className="mt-20"
          />
          <Text
            type='H8'
            text="Vous pouvez réessayer dans quelques instants."
            className="mt-20"
          />
          <Text
            type='H8'
            text={`Si le problème persiste, contactez notre service comptabilité à l'adresse suivante : ${mail}`} 
            className="mt-20"
          />
          
          <TemplateRetryButton pathToPaiement={pathToPaiement} />
        </div>      
      </div>
    );
}

// Validation des props
TemplatePaiementErreur.propTypes = {
  mail: PropTypes.string,
  pathToPaiement: PropTypes.string,
};

export default TemplatePaiementErreur;
